export default __webpack_public_path__ + "01261f323e0df02ca39618d6aeb28486.pdf";